import { useState } from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import AddOfficerModal from './AddOfficerModal'

export const BasicSettings = () => {
  const [addOfficerModalOpen, setAddOfficerModalOpen] = useState(false)

  return (
    <Section
      illustration="user-male-female"
      title={i18n.t('app_store_v2.apps.complaints.settings.basic_settings.title_v2')}
      description={i18n.t('app_store_v2.apps.complaints.settings.basic_settings.description_v2')}
      action={{
        label: i18n.t('app_store_v2.apps.complaints.settings.basic_settings.add_officer'),
        onClick: () => setAddOfficerModalOpen(true),
      }}
    >
      {addOfficerModalOpen && <AddOfficerModal onClose={() => setAddOfficerModalOpen(false)} />}
    </Section>
  )
}
